import React, { useEffect } from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LEGAL_PAGES } from "../legal";
import Footer from "../components/Footer";
import Logo from "../components/Logo";

export default function LegalPage() {
  const { slug } = useParams();
  const page = LEGAL_PAGES[slug];

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!page) return <Navigate to="/" replace />;

  return (
    <div className="bg-1 min-h-screen" data-testid="legal-page">
      <header className="h-[96px] px-6 lg:px-12 flex items-center justify-between border-b border-line">
        <Link to="/" className="text-white" aria-label="Arlan · Inicio" data-testid="legal-logo"><Logo height={40} /></Link>
        <Link to="/" className="link-arrow text-sm" data-testid="legal-back">
          <ArrowLeft className="w-4 h-4" /> Volver a la web
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 lg:px-12 py-20">
        <p className="label">Información legal</p>
        <h1 className="text-4xl lg:text-5xl font-semibold text-white mt-5" data-testid="legal-title">{page.title}</h1>
        <p className="text-muted mt-6 leading-relaxed">{page.intro}</p>
        <div className="mt-14 space-y-10">
          {page.sections.map((s, i) => (
            <section key={s.h} data-testid={`legal-section-${i}`}>
              <h2 className="text-white font-semibold text-xl" data-testid={`legal-section-title-${i}`}>{s.h}</h2>
              {s.p.map((t, j) => <p key={t} className="text-white/75 mt-3 leading-relaxed" data-testid={`legal-section-${i}-paragraph-${j}`}>{t}</p>)}
            </section>
          ))}
        </div>
        <p className="text-muted text-xs mt-16">Última actualización: junio de 2026</p>
      </main>
      <Footer />
    </div>
  );
}
